import type { GetUserRoles } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import apiClient from "@/lib/api/client";

export function useResolveRoles() {
  const { "project-id": projectId } = useSearch({
    from: "/_auth/_app-shell/users/create",
  });

  return useQuery({
    queryFn: () =>
      apiClient
        .url(`/users/create/resolve-roles?isProjectContext=${!!projectId}`)
        .get()
        .json<GetUserRoles>(),
    queryKey: ["user-create-roles"],
  });
}
